import axios, { AxiosInstance, AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { getAuthToken, clearAuthData } from '../utils/auth';

// Create axios instance with base URL and headers
export const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://api.scount.in/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor to add auth token to requests
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getAuthToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
// Define a custom error response type for better type safety
interface ErrorResponse {
  message?: string;
  [key: string]: any;
}

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError<ErrorResponse>) => {
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      clearAuthData();
      // Redirect to login page
      window.location.href = '/login';
      // Note: We'll handle showing the session expired message in the login page
    }

    // Log the error for debugging
    const errorMessage = error.response?.data?.message || 'An error occurred. Please try again.';
    console.error('API Error:', errorMessage, error);

    // Return a rejected promise with the error
    return Promise.reject(error);
  }
);


